import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3033';
const base = `${apiUrl}/api/api-keys`;

export const listApiKeys = () => axios.get(base).then((r) => r.data.apiKeys);
export const createApiKey = (name, allowedOrigins = []) =>
    axios.post(base, {name, allowedOrigins}).then((r) => r.data.apiKey);
export const revokeApiKey = (id) => axios.delete(`${base}/${id}`).then((r) => r.data);
